import React from 'react';
import './custom.css';
import { useEffect, useState } from 'react';
import { collection, doc, getDoc, onSnapshot, setDoc} from 'firebase/firestore'
import {SiGmail} from 'react-icons/si'
import {MdLightMode,MdOutlineLightMode} from 'react-icons/md'
import {FaPhone} from 'react-icons/fa'
import {GrYoutube} from 'react-icons/gr'
import {Animated} from "react-animated-css";
import { db } from '../../utils/Firebase';

const AboutUs = () => {
    const [prjectsList,setPrjectsList] = useState([])
    const [donUrl,setDonUrl] = useState('')
    const [isDescriptionVisible,setIsDescriptionVisible] = useState(true)
    const [currentProject,setCurrentProject] = useState()
    const [isLightMode,setIslightMode] = useState(false)
  
    const LIGHT_COLOR = "#CCC"
    const LIGHT_TEXT_COLOR = "#FFF"
    const LIGHT_PRIMARY_COLOR = "#DDBB87"
    const DARK_COLOR = "#282c34"
    const DARK_TEXT_COLOR = "#282c34"
    const DARK_PRIMARY_COLOR = "#185C19"
  
    let welcomeText = {
      title:'Bienvenue',
      titleSize:50,
      description:"Nous sommes heureux de vous présenter notre projet d'application \"Talibé Cheikh\" dédié à la promotion et à la diffusion de la connaissance sur notre Tariqa Tidjaniya. Ce projet ambitieux a pour but d'offrir une expérience interactive et enrichissante aux utilisateurs, en leur permettant d'acquérir des connaissances sur la Tariqa à leur rythme, et de n'importe où."
            +
            "Nous avons déjà développé des applications telles que Talibé Cheikh, Khilassou Zahab, Lakhdari, ...etc, qui sont actuellement disponibles sur le Play Store et bientôt sur App Store."
            +
            "En plus d'améliorer constamment ces applications via des mises à jour régulières, nous prévoyons de développer d'autres projets pour la Hadara Tidjaniya et pour l'Islam de manière générale.",
      links:[]
    }
    useEffect(()=>{
      setCurrentProject(welcomeText)
  
      onSnapshot(collection(db,'projects'),snapshot => {
        setPrjectsList(snapshot.docs.map(snap => {
          return {...snap.data(),id:snap.id}
        }).sort((a,b)=> a.priority - b.priority))
      })
      getDoc(doc(db,'rules','talibe_cheikh'))
      .then(result => {
        setDonUrl(result.data().faire_un_don_url)
      })
    },[])
  
    const changeMod = ()=> {
      if (isLightMode) {
        window.document.documentElement.style.setProperty('--background-color', DARK_COLOR);
        window.document.documentElement.style.setProperty('--primary-color', LIGHT_PRIMARY_COLOR);
        window.document.documentElement.style.setProperty('--text-color', LIGHT_TEXT_COLOR);
        window.document.documentElement.style.setProperty('--icon-color', LIGHT_COLOR);
      }else{
        window.document.documentElement.style.setProperty('--background-color', LIGHT_COLOR);
        window.document.documentElement.style.setProperty('--primary-color', DARK_PRIMARY_COLOR);
        window.document.documentElement.style.setProperty('--text-color', DARK_TEXT_COLOR);
        window.document.documentElement.style.setProperty('--icon-color', DARK_COLOR);
      }
      setIslightMode(!isLightMode)
    }
    const selectProject = (project) =>{
      
      if(currentProject.id === project.id){
        setCurrentProject(welcomeText)
      }else{
        setCurrentProject(project)
      }
      setIsDescriptionVisible(!isDescriptionVisible)
    }
    return (
      <div className="about-container text-start">
        <div className="background-container"></div>
        <div className="border-left"></div>
        <div className="border-right"></div>
        <div className="content-container">
          <div className="content">
            <div className="row m-0 p-0 pt-4 ps-3 pb-5">
              <img src={require('../../img/icon.png')} className="tc-icon-img " alt="..." />
              <div className="col pt-2 text-end">
                <a href="mailto:dmflthiaroye@gmail.com" target="_blank">
                  <SiGmail className='custom-icon me-4' size={35} />
                </a>
                <a href="https://www.youtube.com/@dahiracap5824" target="_blank">
                  <GrYoutube className='custom-icon me-4' size={35} />
                </a>
                <div className="d-inline d-md-none">
                  <a href="tel:+221772429292" target="_blank">
                    <FaPhone className='custom-icon me-4' size={35} />
                  </a>
                </div>
                {isLightMode?(
                    <MdLightMode className='custom-icon me-4' size={35} onClick={changeMod} />
                  ):(
                    <MdOutlineLightMode className='custom-icon me-4' size={35} onClick={changeMod} />
                  )}
              </div>
            </div>
            <div className="row m-1 m-md-5 mt-5 p-0 projects">
              <div className="col col-md-7">
                 
                <Animated isVisible={isDescriptionVisible} animationInDuration={2000} animationOutDuration={2000} animationIn="bounceInLeft" animationOut="bounceInUp" >
                    {currentProject?.titleSize?
                      <p className="title" style={{fontSize:currentProject.titleSize}}>{currentProject?.title}</p>
                      :
                      <p className="title">{currentProject?.title}</p>
                    }
                    <div className="description">
                      <p>{currentProject?.description}</p>
                      {currentProject?.links?.map((link,index) => (
                          <button className='menu-button mb-2 fw-bold p-0 me-4'>
                            <a href={link.url} target='_blank'>
                              {link.text}
                            </a>
                          </button>
                        ))
                      }
                      <button className='menu-button mb-2 fw-bold p-0 me-4'>
                        <a href={donUrl} target='_blank'>
                          Soutenir le projet
                        </a>
                      </button>
                    </div>
                </Animated>
              </div>
              <div className="col-12 col-md-5 ps-md-5">
                <div className="ms-md-5">
                  <p className='fs-3'>Nos applications</p>
                  <div className="menu-container">
                    <div className="menu p-4">
                      <div>
                        {
                          prjectsList.map((project,index)=> (
                            <div key={index}>
                              <button className='btn menu-button mb-2' onClick={()=>selectProject(project)}>{project.title}</button>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
export default AboutUs;